<template>
  <v-flex
    multiview-body-flex-wrapper
    tall-content-wrapper
    @scroll="debounceScroll"
    ref="wrapper">
    <v-layout class="multiview-browser-body-wrapper">
      <v-data-table
        :items="currentRecords"
        :value="selectedMultiviewExams"
        @input="selectExamsMultiview"
        item-key="exSrNo"
        :items-per-page="-1"
        sort-by="dateIso"
        :sort-desc="true"
        hide-default-footer
        hide-default-header
        :loading="loadingExams"
        :class="tableClass">
        <template slot="item" slot-scope="props">
          <v-row no-gutters class="patientExamMultiviewInfoRow tertiary">
            <v-col cols="auto">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-checkbox
                    class="small-checkbox"
                    :input-value="props.isSelected"
                    :color="colorHex"
                    v-on="on"
                    @click.stop="selectExam(props)"/>
                </template>
                <span>Select/Deselect All in this Exam</span>
              </v-tooltip>
            </v-col>
            <v-col cols="11" class="d-flex align-center justify-center">
              {{ props.item.dateDisplay }} - {{ props.item.exDevice }} -
              <patient-exam-multiview-physician :exam="props.item" />
            </v-col>
          </v-row>
          <patient-exam-multiview-image-thumb-row
            class="patientExamMultiviewThumbbar"
            :exam="props.item"/>
        </template>
      </v-data-table>
    </v-layout>
  </v-flex>
</template>

<script>
// imports
import { mapGetters, mapActions } from "vuex";
import disableScroll from "../mixins/disableScroll";
import patientExamMultiviewImageThumbRow from "./PatientExamMultiviewImageThumbRow";
import patientExamMultiviewPhysician from "./PatientExamMultiviewPhysician";

// exports
export default {
  name: "PatientExamMultiviewBrowserBody",
  components: {
    patientExamMultiviewImageThumbRow,
    patientExamMultiviewPhysician,
  },
  mixins: [disableScroll],
  computed: {
    ...mapGetters([
      "filteredMultiviewExams",
      "selectedMultiviewExams",
      "loadingExams",
      "multiviewIsCollapsed"
    ]),
    possibleRecords() {
      return this.filteredMultiviewExams;
    },
    tableClass() {
      if (this.multiviewIsCollapsed)
        return "patient-list-wrapper collapsed";
      return "patient-list-wrapper";
    }
  },
  methods: {
    ...mapActions(["selectExamsMultiview", "updateCurrentExamsMultiview"]),
    selectExam(props) {
      props.select(!props.isSelected);
    },
    getNthElement(n) {
      let selector = `.patientExamMultiviewInfoRow:nth-child(${n * 2 + 1})`;
      return document.querySelector(selector);
    },
    reportUpdatedBounds(bounds) {
      this.updateCurrentExamsMultiview(bounds);
    },
  },
};
</script>